<template>
  <div class="ai-customer-select" @click="openDialog">
    <span class="ai-customer-select__text text-color-plain text-normal-4 text-overflow-ellipsis">{{
      rangeValueText
    }}</span>
    <!-- 清空图标 -->
    <i
      class="ai-customer-select__clear icon-close-circle-fill t-iconfont"
      @click.stop="resetObjectRange"
    />
    <!-- 下拉图标 -->
    <i class="ai-customer-select__arrow icon-arrow-down-s-line t-iconfont" />
    <!-- 选择 -->
    <CustomerSelect
      v-model:visible="selectVisible"
      :business-type="businessType"
      :default-value="currRangeValue"
      :title="currBusinessTypeInfo.memo"
      @confirm="onConfirm"
    ></CustomerSelect>
  </div>
</template>

<script setup>
import { onMounted, ref, computed, defineProps, defineOptions, defineEmits } from 'vue'
import CustomerSelect from './components/customer-select/index.vue'
import { ENUM_BUSINESS_TYPE_ENTRIES } from '@/components/ai-customer-select/enum.ai-business-select.js'

defineOptions({
  name: 'AiCustomerSelect'
})
import xbb from '@xbb/xbb-utils'
// emits
const emit = defineEmits(['update:modelValue'])
// props
const props = defineProps({
  modelValue: {
    require: true,
    type: Array,
    default: () => []
  },
  businessType: {
    type: Number,
    require: true,
    default: 100
  }
})
// data
const selectVisible = ref(false)
// computed
// 默认选择范围值
const defaultRangeValue = computed({
  set(val) {
    emit('update:modelValue', val)
  },
  get() {
    return props.modelValue
  }
})
const currRangeValue = ref([])
// 当前渲染的businessType
const currBusinessTypeInfo = computed(() => {
  return ENUM_BUSINESS_TYPE_ENTRIES[props.businessType] || {}
})
// 回显文本
const rangeValueText = computed(() => {
  return defaultRangeValue.value.reduce((prev, item) => {
    if (prev) return `${prev},${item.name}`
    return item.name
  }, '')
})
/**
 * 打开弹窗
 */
const openDialog = () => {
  if (defaultRangeValue.value.length === 1 && String(defaultRangeValue.value[0].id) === '0') {
    currRangeValue.value = xbb.deepClone([])
  } else {
    currRangeValue.value = xbb.deepClone(defaultRangeValue.value)
  }
  selectVisible.value = true
}
const onConfirm = (val) => {
  console.log('🚀 ~ onConfirm ~ onConfirm:', val)
  if (val.length === 0) {
    resetObjectRange()
    return
  }
  defaultRangeValue.value.splice(0, defaultRangeValue.value.length, ...val)
}
const resetObjectRange = () => {
  defaultRangeValue.value = [
    {
      id: 0,
      name: `全部${currBusinessTypeInfo.value.memo}`
    }
  ]
}
// lice-cycle
onMounted(() => {})
</script>

<style lang="less" scoped>
.ai-customer-select {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 8px;
  width: 96px !important;
  cursor: pointer;

  &__text {
    margin-right: 8px;
  }

  // 默认显示下拉图标，隐藏清空图标
  &__clear {
    display: none;
  }

  &__arrow {
    display: inline-block;
  }

  // 鼠标悬停时显示清空图标，隐藏下拉图标
  &:hover {
    .ai-customer-select__clear {
      display: inline-block;
    }

    .ai-customer-select__arrow {
      display: none;
    }
  }
}
</style>
